import cx from 'classnames';
import ComposerUiMfe from './ComposerUiMfe';

type OwnProps = {
  buttonClassName?: string;
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
};

export default function ComposerUiWidget({
  buttonClassName,
  isOpen,
  onClose,
  onOpen
}: OwnProps) {
  return (
    <>
      <button
        className={cx(
          'fixed bottom-2xl left-1/2 z-10 -translate-x-1/2 rounded-full bg-background-success px-16 py-8 shadow-lg t-label-sm text-white',
          buttonClassName
        )}
        data-analytics-id="Composer UI - Open"
        data-testid="Composer UI"
        onClick={onOpen}
        type="button"
      >
        Composer
      </button>
      <ComposerUiMfe isOpen={isOpen} onRequestClose={onClose} />
    </>
  );
}
